export const API_BASE = "https://safemaps-backend.onrender.com";